import React from 'react';
import ReactDOM from 'react-dom';
import { translate } from 'react-i18next';

import ShiftDetailBlock from 'components/ScheduleSidebar/ShiftDetailBlock.js';
import EmployeeActions from 'actions/EmployeeActions.js';
import Popover from 'components/popover/Popover.js';

class SidebarShiftDetails extends React.Component {
  constructor(props) {
    super(props);

    this.onExchangeClick = this.onExchangeClick.bind(this);
    this.onDropClick = this.onDropClick.bind(this);
    this.onPostExchange = this.onPostExchange.bind(this);
    this.onDropPostExchange = this.onDropPostExchange.bind(this);
    this.onViewOffers = this.onViewOffers.bind(this);
    this.onCancelPost = this.onCancelPost.bind(this);
    this._onHandleClosePopover = this._onHandleClosePopover.bind(this);

    this.onSuccessfulPost = this.onSuccessfulPost.bind(this);
    this.onUnsuccessfulPost = this.onUnsuccessfulPost.bind(this);
    this.onSuccessfulBid = this.onSuccessfulBid.bind(this);

    this.state = {
      pending: false,
      popOverActive: false,
      dropPopOverActive: false,
      popTarget: null,
      popOverErrorMessage: null,
    };
  }

  componentDidMount() {
    ExchangesStore.on('exchanges:post:advertisment:success', this.onSuccessfulPost);
    ExchangesStore.on('exchanges:post:advertisment:error', this.onUnsuccessfulPost);
    ExchangesStore.on('exchanges:bid:advertisment:success', this.onSuccessfulBid);

    document.addEventListener('popover:closed', this._onHandleClosePopover, this);
  }

  componentWillUnmount() {
    ExchangesStore.off('exchanges:post:advertisment:success', this.onSuccessfulPost);
    ExchangesStore.off('exchanges:post:advertisment:error', this.onUnsuccessfulPost);
    ExchangesStore.off('exchanges:bid:advertisment:success', this.onSuccessfulBid);

    document.removeEventListener('popover:closed', this._onHandleClosePopover, this);
  }

  onSuccessfulBid(collection, response) {
    this.setState({
      pending: true,
    });
  }

  _onHandleClosePopover(e) {
    if (ReactDOM.findDOMNode(this).contains(e.popOver)) {
      this._onClosePopover();
    }
  }

  _onClosePopover() {
    this.setState({
      popOverActive: false,
      popTarget: null,
    });
  }

  onSuccessfulPost(response) {
    this.setState({
      popOverActive: false,
      dropPopOverActive: false,
      popTarget: null,
    });
    if (response.shift_id == this.props.shiftData.id) {
      this.forceUpdate();
    }
  }

  onUnsuccessfulPost(response) {
    this.setState({
      popOverErrorMessage: JSON.parse(response.responseText).error_message,
    });
  }

  onTextAreaInput(e) {
    this.setState({
      popOverErrorMessage: null,
    });
  }

  onViewOffers(e) {
    const type = 'my exchange';
    const selectedShift = this.props.shiftData;
    this.props.toggleOpenSidebar(type, selectedShift);

    e.stopPropagation();
  }

  onCancelPost(e) {
    let shift_id = this.props.shiftData.id;
    let exchange = ExchangesStore.getExchangeByShiftId(shift_id);
    let exchange_id = null;
    if (_.isEmpty(exchange)) {
      exchange = Utils.getFirstActiveExchange(this.props.shiftData.exchanges);
      exchange_id = exchange.id;
      shift_id = exchange.shift_id;
    } else {
      exchange_id = exchange.id;
      shift_id = exchange.shift_id;
    }
    if (exchange_id) {
      EmployeeActions.cancelExchange(exchange_id, shift_id);
    }
  }

  onPostExchange(e) {
    if (EmployeeActions) {
      EmployeeActions.postExchange(
        this.props.shiftData.id,
        false,
        ReactDOM.findDOMNode(this).querySelector('.popoverexchange textarea#exchangeNote').value,
      );
    }
    e.stopPropagation();
  }

  onDropPostExchange(e) {
    if (EmployeeActions) {
      EmployeeActions.postExchange(
        this.props.shiftData.id,
        true,
        ReactDOM.findDOMNode(this).querySelector('.popoverdrop textarea#dropNote').value,
      );
    }

    e.stopPropagation();
  }

  onExchangeClick(e) {
    this.setState({
      popOverActive: !this.state.popOverActive,
      dropPopOverActive: false,
      popTarget: e.currentTarget,
    });
  }

  onDropClick(e) {
    this.setState({
      popOverActive: false,
      dropPopOverActive: !this.state.dropPopOverActive,
      popTarget: e.currentTarget,
    });
  }

  isExchanged(data) {
    let bool = false;
    if (!Utils.isNotDefined(data)) {
      const len = data.length;
      for (let i = 0; i < len; i++) {
        let obj = data[i];
        if (!obj.user_id) {
          obj = data[i];
        }
        if (parseInt(obj.user_id, 10) === parseInt(Utils.getCoreUser().id, 10)) {
          if (obj.state !== 'approved' && data[i].state !== 'rejected') {
            bool = true;
          }
        }
      }
    }
    return bool;
  }

  isPending(data) {
    let bool = false;

    if (!Utils.isNotDefined(data)) {
      const len = data.length;
      for (let i = 0; i < len; i++) {
        let obj = data[i];
        if (!obj.state) {
          obj = data[i];
        }
        if (obj.state === 'accepted') {
          bool = true;
        }
      }
    }

    return bool;
  }

  render() {
    let startTime = '';
    let endTime = '';

    const acceptedExchange = !_.isEmpty(
      ExchangesStore.getExchangeByAcceptedShiftId(this.props.shiftData.id),
    );

    if (this.props.active) {
      startTime = moment(this.props.shiftData.start_time)
        .tz(this.props.shiftData.time_zone)
        .format('h:mm a');
      endTime = moment(this.props.shiftData.end_time)
        .tz(this.props.shiftData.time_zone)
        .format('h:mm a');
      var hideEnd = this.props.shiftData.hide_end_time;
    }
    let buttonLabel = this.props.t('SidebarShiftDetails.post_shift');
    const exchanged = this.isExchanged(this.props.shiftData.exchanges);
    const validExchange = Utils.getFirstActiveExchange(this.props.shiftData.exchanges, true);
    if (exchanged && validExchange != null) {
      if (!Utils.isNotDefined(validExchange.drop) && validExchange.drop) {
        buttonLabel = this.props.t('SidebarShiftDetails.posted_for_drop');
      } else {
        buttonLabel = this.props.t('SidebarShiftDetails.posted_for_exchange');
      }
    }

    const pending = this.isPending(this.props.shiftData.exchanges);
    let cancelDisabled = '';
    if (pending || this.state.pending) {
      buttonLabel = this.props.t('SidebarShiftDetails.exchange_pending_approval');
      if (!Utils.isNotDefined(validExchange.drop) && validExchange.drop) {
        buttonLabel = this.props.t('SidebarShiftDetails.drop_pending_approval');
      }
      cancelDisabled = 'disabled';
    }

    let disableExchange = '';
    let disableDrop = '';
    if (acceptedExchange) {
      buttonLabel = this.props.t('SidebarShiftDetails.exchange_pending_approval');
      disableExchange = 'disabled';
      disableDrop = 'disabled';
    }

    const exchange = this.props.shiftData && this.props.shiftData && this.props.shiftData.id
      ? ExchangesStore.getExchangeByShiftId(this.props.shiftData.id)
      : null;
    const bids = exchange != null && exchange && exchange.bids ? exchange.bids : [];
    let disabled = '';
    if (bids.length == 0 || this.state.pending) {
      disabled = 'disabled';
    }

    const pendingExchange = !_.isEmpty(
      ExchangesStore.myAcceptedShiftExchanges.filter( (x) => { return x.accepted_shift_id == this.props.shiftData.id })
    );

    if (pendingExchange || exchange.state == 'accepted') {
      disabled = 'disabled';
      cancelDisabled = 'disabled';
    }

    const today = moment(new Date().setHours(0, 0, 0, 0));
    const hideDetailActions = moment(this.props.selectedDate).isBefore(today) ? 'hide' : '';
    const exchangeNoteClasses = `calendar-input-bullet small exchange ${hideDetailActions}`;
    const exchangeButtonClasses = `full-flex-container exchange-buttons ${hideDetailActions}`;

    const classes = `calendar-input shift-details ${!this.props.active ? 'hide' : ''}`;

    let departmentId;
    let locationId;
    let position;
    let job_site_name;
    let job_site_address;
    let notes;

    if (this.props.hasOwnProperty('shiftData')) {
      departmentId = this.props.shiftData.department_id;
      locationId = this.props.shiftData.location_id;
      position = this.props.shiftData.position;
      job_site_name = this.props.shiftData.job_site_name;
      job_site_address = this.props.shiftData.job_site_address;
      notes = this.props.shiftData.shift_notes;
    }

    let breaks = null;
    if (
      !Utils.isNotDefined(this.props.shiftData)
      && !Utils.isNotDefined(this.props.shiftData.breaks)
    ) {
      breaks = Utils.formatUnformattedBreaks(this.props.shiftData.breaks);
    }

    return (
      <div>
        <div className={classes}>
          <span className="calendar-input-bullet shift-bullet">{this.props.t('SidebarShiftDetails.shift_details')}</span>
          <div className="shift-detail-content">
            <p className="shift-detail-title">
              {this.props.shiftData ? this.props.shiftData.name : ''}
              <br />
              {startTime}
              {' – '}
              {!hideEnd ? endTime : this.props.t('SidebarShiftDetails.tbd')}
            </p>
            {!Utils.isNotDefined(breaks) && (
              <p className="shift-detail-breaks">
                {this.props.t('SidebarShiftDetails.breaks')}:&nbsp;
                {breaks}
              </p>
            )}
            <ShiftDetailBlock
              departmentID={departmentId}
              locationID={locationId}
              position={position}
              job_site_name={job_site_name}
              job_site_address={job_site_address}
            />
            {!Utils.isNotDefined(this.props.shiftData.shift_notes) && (
              <div className="shift-detail-notes-container">
                <p className="shift-detail-title">{this.props.t('SidebarShiftDetails.notes').toUpperCase()}</p>
                <p className="shift-detail-notes">{notes}</p>
              </div>
            )}
          </div>
          <div className={exchangeButtonClasses}>
            <button
              className={
                exchanged
                  ? 'calendar-input-button half view-offers-button'
                  : 'calendar-input-button half view-offers-button hide'
              }
              onClick={e => this.onViewOffers(e)}
              disabled={disabled}
            >
              {this.props.t('SidebarShiftDetails.view_offers')}
            </button>
            <button
              className={
                exchanged
                  ? 'calendar-input-button half cancel-post-button'
                  : 'calendar-input-button half cancel-post-button hide'
              }
              onClick={e => this.onCancelPost(e)}
              disabled={cancelDisabled}
            >
              {this.props.t('SidebarShiftDetails.cancel_post')}
            </button>
            <button
              className={
                Utils.getCoreUser().company.allow_exchanges_and_drops && !exchanged
                  ? 'calendar-input-button half shift-exchange-button'
                  : 'calendar-input-button half shift-exchange-button hide'
              }
              onClick={e => this.onExchangeClick(e)}
              disabled={disableExchange}
            >
              {this.props.t('SidebarShiftDetails.exchange')}
            </button>
            <button
              className={
                Utils.getCoreUser().company.allow_exchanges_and_drops && !exchanged
                  ? 'calendar-input-button half shift-drop-button'
                  : 'calendar-input-button half shift-drop-button hide'
              }
              onClick={e => this.onDropClick(e)}
              disabled={disableDrop}
            >
              {this.props.t('SidebarShiftDetails.drop')}
            </button>
          </div>
        </div>
        <Popover
          onHide={e => this._onClosePopover(e)}
          position="right"
          className="popoverexchange"
          active={this.state.popOverActive}
          popTarget={this.state.popTarget}
        >
          <h3>{this.props.t('SidebarShiftDetails.post_for_exchange')}</h3>
          <form
            id="exchangeFormContainer"
            className={!Utils.isNotDefined(this.state.popOverErrorMessage) ? 'error' : null}
          >
            <label htmlFor="exchangeNote">{this.props.t('SidebarShiftDetails.note_optional')}</label>
            <textarea
              id="exchangeNote"
              name="exchangeNote"
              placeholder=""
              maxLength="255"
              onInput={e => this.onTextAreaInput(e)}
            />
            <span className="error-message">{this.state.popOverErrorMessage}</span>
            <p>
              {this.props.t('SidebarShiftDetails.will_be_posted_for_exchange')}
            </p>
          </form>
          <div className="btn-group pull--right">
            <button
              className="button button--inline exchange-cancel-button"
              onClick={this.onExchangeClick}
            >
              {this.props.t('SidebarShiftDetails.close')}
            </button>
            <button
              className="button button--recommended button--inline exchange-post-button"
              onClick={this.onPostExchange}
            >
              {this.props.t('SidebarShiftDetails.post')}
            </button>
          </div>
        </Popover>
        <Popover
          ref="popoverDrop"
          position="right"
          className="popoverdrop"
          active={this.state.dropPopOverActive}
          popTarget={this.state.popTarget}
        >
          <h3>{this.props.t('SidebarShiftDetails.post_for_drop')}</h3>
          <form
            id="exchangeFormContainer"
            className={!Utils.isNotDefined(this.state.popOverErrorMessage) ? 'error' : null}
          >
            <label htmlFor="dropNote">{this.props.t('SidebarShiftDetails.note_optional')}</label>
            <textarea
              id="dropNote"
              name="dropNote"
              placeholder=""
              maxLength="255"
              onInput={e => this.onTextAreaInput(e)}
            />
            <span className="error-message">{this.state.popOverErrorMessage}</span>
            <p>{this.props.t('SidebarShiftDetails.will_be_posted_for_drop')}</p>
          </form>
          <div className="btn-group pull--right">
            <button className="button button--inline drop-cancel-button" onClick={this.onDropClick}>
              {this.props.t('SidebarShiftDetails.close')}
            </button>
            <button
              className="button button--recommended button--inline drop-post-button"
              onClick={this.onDropPostExchange}
            >
              {this.props.t('SidebarShiftDetails.post')}
            </button>
          </div>
        </Popover>
      </div>
    );
  }
}

export default translate()(SidebarShiftDetails);
